export default "__VITE_ASSET__DXQMzXOt__"